/**
 * Online/offline detection — pluggable per-platform.
 *
 * Web uses `window.online/offline` events + `navigator.onLine`. React Native
 * uses `@react-native-community/netinfo`. The sync engine only depends on
 * this interface.
 *
 * Register a platform implementation once at app startup with
 * `setOnlineDetector(...)`. If nothing is registered, the engine falls back
 * to "always online" — safe for environments without connectivity info (CLI,
 * tests, SSR).
 */

export type OnlineDetector = {
  /** Subscribe to connectivity changes. Fires on BOTH online and offline events. */
  subscribe(cb: () => void): () => void;
  /** Current online state on the client. */
  getSnapshot(): boolean;
  /** Snapshot used during SSR / hydration. Typically `true`. */
  getServerSnapshot(): boolean;
};

const ALWAYS_ONLINE: OnlineDetector = {
  subscribe: () => () => {},
  getSnapshot: () => true,
  getServerSnapshot: () => true,
};

let _detector: OnlineDetector = ALWAYS_ONLINE;

export function setOnlineDetector(detector: OnlineDetector): void {
  _detector = detector;
}

export function getOnlineDetector(): OnlineDetector {
  return _detector;
}
